import React from 'react';
import { FlameIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { BRAND, OFFER_SECTION_ID } from '../../data/salesContent';
// Tailwind zinc-800, used for the decorative technical grid
const GRID_LINE = 'rgb(39 39 42)';
export function HeroSection() {
  return <header className="relative overflow-hidden border-b border-zinc-800 bg-zinc-950 px-5 pb-16 pt-5 md:pb-24 md:pt-14" data-id="element-132" data-mp="1x87uetfffv7j">
      <div className="pointer-events-none absolute inset-0 opacity-60" style={{
      backgroundImage: `linear-gradient(${GRID_LINE} 1px, transparent 1px), linear-gradient(90deg, ${GRID_LINE} 1px, transparent 1px)`,
      backgroundSize: '56px 56px',
      maskImage: 'linear-gradient(to bottom, black, transparent 85%)',
      WebkitMaskImage: 'linear-gradient(to bottom, black, transparent 85%)'
    }} aria-hidden="true" data-id="element-133" data-mp="1sbr884rsfqx3" />
      <div className="relative mx-auto max-w-6xl" data-id="element-134" data-mp="14kc17yp2glfi">
        <p className="font-display flex items-center justify-center gap-2 text-sm font-extrabold uppercase tracking-[0.25em] text-zinc-50 md:text-base lg:justify-start" data-id="element-135" data-mp="14klrlne0wulq">
          <FlameIcon className="h-4 w-4 text-amber-400" aria-hidden="true" data-id="element-136" data-mp="36f4dkqcmli5m" />
          {BRAND}
        </p>
        <div className="mt-4 grid items-center gap-x-12 gap-y-4 md:mt-10 md:gap-y-8 lg:grid-cols-[1.05fr_1fr]" data-id="element-137" data-mp="2soha6kvx7437">
          <h1 className="font-display text-center text-[2rem] font-black uppercase leading-[1] text-zinc-50 sm:text-5xl md:text-6xl lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-138" data-mp="2wpufmtv3p59l">
            Dejá de preparar cada capacitación bomberil <span className="text-amber-400" data-id="element-139" data-mp="3pbchnqtwjmzc">desde cero.</span>
          </h1>

          <ProductImage className="mx-auto w-full max-w-[290px] sm:max-w-md lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:max-w-xl" data-id="element-140" data-mp="3bdnycnfhgnwe" />

          <div className="text-center lg:col-start-1 lg:row-start-2 lg:self-start lg:text-left" data-id="element-141" data-mp="1zz20byfzrh8v">
            <CtaButton scrollToId={OFFER_SECTION_ID} data-id="element-142" data-mp="24xvbvlbpwy6e">Quiero el sistema completo</CtaButton>
            <p className="font-display mt-5 text-2xl font-extrabold uppercase text-zinc-50 md:text-3xl" data-id="element-143" data-mp="ahn9jjn801iy">
              6 volúmenes <span className="text-amber-400" data-id="element-144" data-mp="5i1y49qv60pc">+</span> 5 bonos prácticos
            </p>
            <p className="mt-1 text-sm font-medium text-zinc-400" data-id="element-145" data-mp="rtv8avp18b0">100% digital · Acceso inmediato</p>
            <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-zinc-400 lg:mx-0" data-id="element-146" data-mp="3svw696f1j1uq">
              Pensado para instructores de bomberos voluntarios, responsables de capacitación y formadores de aspirantes.
            </p>
          </div>
        </div>
      </div>
    </header>;
}